import { render, staticRenderFns } from "./locTypeWithField.vue?vue&type=template&id=1ce584c4"
import script from "./locTypeWithField.vue?vue&type=script&lang=js"
export * from "./locTypeWithField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports